import PropTypes from 'prop-types'
import { getPendingRegionSwitch } from '@common/src/config/regions'

const base = import.meta.env.BASE_URL

// Same look as the static #boot-screen in index.html (inline styles, files in public/boot), so the page can hand
// over between them during start-up and a region-switch reload without a visible blink.
const styles = {
  screen: {
    position: 'fixed',
    inset: 0,
    zIndex: 10000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    background: 'rgb(240 241 247)',
    color: 'rgb(51 51 53)',
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    fontWeight: 500,
  },
  logo: { height: 40 },
  spinner: { width: 80, height: 80 },
  text: { margin: 0 },
}

/** "Switching to <region>…" during the first load after a region switch, otherwise "Loading…". */
export const bootMessage = () => {
  const switchingTo = getPendingRegionSwitch()
  return switchingTo ? `Switching to ${switchingTo}…` : 'Loading…'
}

/** Full-screen loading screen: logo, spinner and a message. */
const BootScreen = ({ message }) => (
  <div style={styles.screen} role="status" aria-live="polite">
    <img src={`${base}boot/logo.png`} alt="Chicking" style={styles.logo} />
    <img src={`${base}boot/loader.svg`} alt="" style={styles.spinner} />
    <p style={styles.text}>{message || bootMessage()}</p>
  </div>
)

BootScreen.propTypes = {
  message: PropTypes.string,
}

export default BootScreen
